import moment from 'moment-timezone';
import { date, object, string, number, array } from 'yup';
import { transformEmptyStringToNull, transformNullToUndefined, transformNaNToUndefined } from '../../../../../../custom-components/form-schemas/Schema.utils';

const MutateSupplyCellSchema = object()
    .shape({
        route_id: string().required('Route is required'),
        producer_ids: array().of(string()).min(1, 'Producers must contain at least 1 item'),
        start_date: date()
            .required('Start date is required')
            .test('start_date before end_date', 'Start date must be before end date', function (value) {
                const { end_date } = this.parent;
                if (!value || !end_date) return true;
                const start = moment(value);
                const end = moment(end_date);
                return start.isBefore(end);
            }),
        processor_id: string().optional().transform(transformNullToUndefined),
        bill_to_processor_id: string().optional().transform(transformNullToUndefined),
        driver_id: string().optional().transform(transformNullToUndefined),
        end_date: date()
            .required('End date is required')
            .test('end_date after start_date', 'End date must be after start date', function (value) {
                const { start_date } = this.parent;
                if (!value || !start_date) return true;
                const start = moment(start_date);
                const end = moment(value);
                return end.isAfter(start);
            }),
        hauling_id: string().optional().transform(transformNullToUndefined),
        amount: number().required('Amount is required').min(1, 'Amount must be 1 or greater'),
        producer_pickup_sequence: array()
            .of(
                object().shape({
                    expected_amount: number().required('Amount is required').min(0, 'Amount must be 0 or greater'),
                    producer_id: string().required('Producer is required'),
                })
            )
            .min(1, 'Producer pickup sequence must contain at least 1 item')
            .optional()
            .nullable(),
        protein: number().min(0, 'Protein must be 0 or greater').optional().transform(transformNaNToUndefined),
        notes: string().optional().transform(transformEmptyStringToNull).nullable(),
        milk_category: string().optional(),
        po_number: string().optional().transform(transformEmptyStringToNull).nullable(),
        delivery_hauler_id: string().optional().transform(transformNullToUndefined),
    })
    .meta({
        // fields that we need to extract the _id from within data grid edit cells
        extractIdFields: ['route_id', 'processor_id', 'bill_to_processor_id', 'hauling_id'],
    });
export default MutateSupplyCellSchema;
